import { Component, OnInit } from '@angular/core';
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter } from 'angular-slickgrid';
import { SelectItem } from 'primeng/api';
import { Valorizacion } from '../entidades/entidades.component';
import { AveriasService } from '../servicios/averias.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'app-valorizacion',
    templateUrl: './valorizacion.component.html',
    styleUrls: ['./valorizacion.component.css'],
    standalone: true,
    imports: [CommonModule, DropdownModule, FormsModule, MatIconModule, NbCardModule, NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, SpinnerComponent, MultiSelectModule],
})
export class ValorizacionComponent implements OnInit {

  loadingResponse = false;
  dataset: any[] = [];
  showSpinner = false;
  cargarGrilla = false;
  showGrilla = false;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  gridObj: any;
  angularGrid: AngularGridInstance;
  dataView: any;
  durationInSeconds = 3;
  firstForm: UntypedFormGroup;
  idCliente: number;
  severidadCompleto;
  severidad: SelectItem[];
  showSeveridad = false;
  idSeveridad: number;
  severidadOK = false;
  tipoCompleto;
  tipo: SelectItem[];
  showTipo = false;
  idTipo: number;
  tipoOK = false;
  operadores: SelectItem[];
  showOperadores = false;
  idOperadores: number;
  operadoresOK = false;
  showSpinnerGuardar = false;
  operadorSeleccionado;
  tipoAveriaSeleccionada;
  severidadSeleccionada;
  valorSeleccionado;
  tipoAveriaSeleccionadaModificar;
  severidadSeleccionadaModificar;
  valorSeleccionadoModificar;
  operadoresModificar;


  operadorEditar;
  tipoAveriaEditar;
  severidadEditar;
  valorEditar;

  datasetConsulta: any[] = [];
  showSpinnerConsulta = false;
  cargarGrillaConsultar = false;
  showGrillaConsulta = false;
  columnDefinitionsConsulta: Column[];
  gridOptionsConsulta: GridOption;
  angularGridConsulta: AngularGridInstance;

  constructor(private _snackBar: MatSnackBar, private fb: UntypedFormBuilder, private AveriasService: AveriasService) { }

  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem('idCliente'));
    this.firstForm = this.fb.group({
      firstCtrl: ['-', Validators.required],
    });
    this.consultarOperadores();
    this.consultarSeveridad();
    this.consultarTipo();
  }

  consultarSeveridad() {
    this.showSpinner = true;
    this.AveriasService.getSeveridad(this.idCliente).subscribe(
      data => {
        this.severidadCompleto = data;
        this.severidad = this.insertarSeveridad(data);
        this.showSeveridad = true;
      });
  }

  consultarSeveridadModificar() {
    this.showSpinner = true;
    this.AveriasService.getSeveridad(this.idCliente).subscribe(
      data => {
        this.severidadCompleto = data;
        this.severidad = this.insertarSeveridad(data);
        this.showSeveridad = true;
      });
  }
  insertarSeveridad(armarSeveridad) {
    let averiasSeveridad: Array<any> = [];
    armarSeveridad.content.forEach(element => {
      averiasSeveridad.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasSeveridad;
  };
  capturarSeveridad(event) {
    this.idSeveridad = event;
    this.severidadOK = true;
  }

  consultarTipo() {
    this.showSpinner = true;
    this.AveriasService.getTipo(this.idCliente).subscribe(
      data => {
        this.tipoCompleto = data;
        this.tipo = this.insertarTipo(data);
        this.showTipo = true;
      });
  }
  insertarTipo(armarTipo) {
    let averiasTipo: Array<any> = [];
    armarTipo.content.forEach(element => {
      averiasTipo.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasTipo;
  };
  capturarTipo(event) {
    this.idTipo = event;
    this.tipoOK = true;
  }

  consultarOperadores() {
    this.AveriasService.getOperadores().subscribe(
      data => {
        this.operadores = this.insertarOperadores(data);
        this.showOperadores = true;
      });
  }
  insertarOperadores(armarOperadores) {
    let averiasOperadores: Array<any> = [];
    armarOperadores.content.forEach(element => {
      averiasOperadores.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasOperadores;
  };
  capturarOperadores(event) {
    this.idOperadores = event;
    this.operadoresOK = true;
  }


  //Grilla Valorizacion
  traerDatosValorizacion() {
    this.loadingResponse = true;

    let mockDataset : any = [];
    // for (let i = 0; i < Valorizacion.length; i++) {
      mockDataset.push({
        id: 1,
        Operador: '',
        TipoAveria: '',
        Severidad: '',
        Valor: '',
      });
    // }
    this.dataset  = mockDataset;
    this.showSpinner = false;
    this.showGrilla = true;
    this.fillGrilla();
  }
  fillGrilla() {
    this.columnDefinitions = [
      { id: 'Operador', name: 'Operador', field: 'Operador', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'TipoAveria', name: 'Tipo Avería', field: 'TipoAveria', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'Severidad', name: 'Severidad', field: 'Severidad', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'Valor', name: 'Valor', field: 'Valor', sortable: true, filterable: true, minWidth: 100, width: 100},
    ];
    this.gridOptions = {
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }

  traerDatosValorizacionConsulta() {
    this.loadingResponse = true;

    let mockDataset : any = [];
    // for (let i = 0; i < Valorizacion.length; i++) {
      mockDataset.push({
        id: 1,
        Operador: '',
        TipoAveria: '',
        Severidad: '',
        Valor: '',
      });
    // }
    this.datasetConsulta  = mockDataset;
    this.showSpinnerConsulta = false;
    this.showGrillaConsulta = true;
    this.fillGrillaConsulta();
  }
  fillGrillaConsulta() {
    this.columnDefinitionsConsulta = [
      { id: 'Operador', name: 'Operador', field: 'Operador', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'TipoAveria', name: 'Tipo Avería', field: 'TipoAveria', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'Severidad', name: 'Severidad', field: 'Severidad', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'Valor', name: 'Valor', field: 'Valor', sortable: true, filterable: true, minWidth: 100, width: 100},
    ];
    this.gridOptionsConsulta = {
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }

  angularGridReady(angularGrid: AngularGridInstance){
    this.angularGrid = angularGrid;
    this.dataView = angularGrid.dataView;
    this.gridObj = angularGrid && angularGrid.slickGrid || {};
    this.angularGrid.resizerService.pauseResizer(false)
  }

  angularGridReadyConsulta(angularGrid: AngularGridInstance){
    this.angularGridConsulta = angularGrid;
    this.dataView = angularGrid.dataView;
    this.gridObj = angularGrid && angularGrid.slickGrid || {};
    this.angularGridConsulta.resizerService.pauseResizer(false)
  }

  // obtenerDescripcionDropdown(IdTipo: number) {
  //   let resp = this.tipoCompleto.content.find(n => n['id'] == IdTipo);
  //   this.operadorEditar = resp['operador'];
  //   this.tipoAveriaEditar = resp['tipoAveria'];
  //   this.severidadEditar = resp['severidad'];
  //   this.valorEditar = resp['valor'];
  // }
}
